import {KeyboardKeys} from "../utils/consts";

class DigitInput {
  #digitWrapperElement;
  #inputForMergedTextElement;
  #digitsElements;

  #length;

  #fullValue = ``;

  /**
   *
   * @param {HTMLElement} wrapperElement - Обертка всех инпутов
   * @param {HTMLInputElement?} inputForMergedTextElement - инпут для получения целого значения
   */
  constructor(wrapperElement, inputForMergedTextElement) {
    try {
      this.#digitWrapperElement = wrapperElement;

      if (!this.#digitWrapperElement) {
        throw new Error(`Вы не передали обязательный элемент обертку wrapperElement для поиска инпутов в нём`);
      }

      this.onDigitInput = this.onDigitInput.bind(this);
      this.onCodeFieldPaste = this.onCodeFieldPaste.bind(this);
      this.onCodeFieldKeyDown = this.onCodeFieldKeyDown.bind(this);

      this.#inputForMergedTextElement = inputForMergedTextElement;
      this.#digitsElements = this.#digitWrapperElement.querySelectorAll(`.js-one-digit`);

      if (this.#digitsElements.length > 0) {
        this.#length = this.#digitsElements.length;

        this.#digitsElements.forEach((digit) => {
          digit.addEventListener(`input`, this.onDigitInput);
          digit.addEventListener(`paste`, this.onCodeFieldPaste);
          digit.addEventListener(`keydown`, this.onCodeFieldKeyDown);
        });
      } else {
        throw new Error(`В разметке не найдены инпуты для ввода, или у инпутов не указан класс js-one-digit`);
      }
    } catch(e) {
      console.error(e);
    }
  }

  #setFullValue() {
    this.#fullValue = Array.from(this.#digitsElements)
      .reduce((previousValue, currentValue) => {
        return `${previousValue}${currentValue.value}`;
      }, ``);

    if (this.#inputForMergedTextElement) {
      this.#inputForMergedTextElement.value = this.#fullValue;
    }
  }

  /**
   * Получаем статус заполненности поля.
   * @returns {boolean}
   */
  get isValid() {
    return this.#fullValue.length === this.#length;
  }

  get code() {
    return this.#fullValue;
  }

  /**
   * Отключаем ввод в поля
   */
  disabledInput() {
    if (this.#digitWrapperElement.tagName === `FIELDSET`) {
      this.#digitWrapperElement.disabled = `disabled`;
      return;
    }

    this.#digitsElements.forEach((digit) => digit.disabled = `disabled`);
  }

  /**
   * Включаем ввод в поля
   */
  enableInput() {
    if (this.#digitWrapperElement.tagName === `FIELDSET`) {
      this.#digitWrapperElement.disabled = null;
      return;
    }

    this.#digitsElements.forEach((digit) => digit.disabled = null);
  }


  onDigitInput(evt) {
    const self = evt.currentTarget;
    const index = Array.from(this.#digitsElements)
      .indexOf(self);

    if (self.value.length === 1 && index + 1 < this.#length) {
      this.#digitsElements[index + 1].focus();
    }

    this.#setFullValue();
  }

  onCodeFieldPaste(evt) {
    evt.preventDefault();

    const pasteData = evt.clipboardData.getData(`text/plain`);

    if (pasteData.match(/^\d+$/) !== null) {
      this.#digitsElements.forEach((input, index) => {
        if (pasteData[index]) {
          input.value = pasteData[index];
        }
      });

      if (pasteData.length > this.#length) {
        this.#digitsElements[this.#length - 1].focus();
      } else {
        this.#digitsElements[pasteData.length - 1].focus();
      }
    }

    this.#setFullValue();
  }

  onCodeFieldKeyDown(evt) {
    const self = evt.currentTarget;
    const index = Array.from(this.#digitsElements)
      .indexOf(self);

    if (index === this.#length - 1 && self.value.length && evt.key !== KeyboardKeys.BACKSPACE) {
      evt.preventDefault();
      return;
    }

    if (evt.key === KeyboardKeys.BACKSPACE && index !== 0 && self.value.length === 0) {
      const value = this.#digitsElements[index - 1].value;
      this.#digitsElements[index - 1].focus();
      this.#digitsElements[index - 1].value = value;
    }

    this.#setFullValue();
  }
}

export {DigitInput};
